import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { HttpLink } from "@apollo/client/link/http";
import { ApolloProvider } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { authHeaders } from "@/utils";

const GraphQLProvider = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0();

    const apolloClient = useMemo(() => {
        const graphQLLink = new HttpLink({ uri: import.meta.env.VITE_GRAPHQL_SERVER });

        return new ApolloClient({
            cache: new InMemoryCache(),
            connectToDevTools: true,
            defaultOptions: {
                watchQuery: { fetchPolicy: "cache-and-network" },
            },
            link: authHeaders(getAccessTokenSilently).concat(graphQLLink),
        });
    }, [getAccessTokenSilently]);

    return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default GraphQLProvider;

GraphQLProvider.propTypes = { children: PropTypes.any };
